import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { Download } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const downloadEl = async (id, filename) => {
  const el = document.getElementById(id);
  if (!el) return;
  const canvas = await html2canvas(el, { scale: 4, useCORS: true, backgroundColor: null });
  const link = document.createElement('a');
  link.download = filename + '.png';
  link.href = canvas.toDataURL('image/png');
  link.click();
};

const QRPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#111', padding: 40, fontFamily: 'Inter, sans-serif', color: '#fff' }}>
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 8px' }}>QR Code — Colabella Group</h1>
        <p style={{ color: '#9ca3af', fontSize: 14 }}>Clicca "Scarica" per salvare in alta risoluzione. Pronto per stampa su carta intestata, biglietti, adesivi.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, maxWidth: 1000, margin: '0 auto' }}>

        {/* QR 1 - Sito Web */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-sito" style={{ background: '#fff', borderRadius: 16, padding: 24, textAlign: 'center', width: 280 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 14 }}>
              <img src={LOGO} alt="" style={{ width: 32, height: 32 }} crossOrigin="anonymous" />
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: '#1a365d', letterSpacing: '0.08em' }}>COLABELLA GROUP</div>
                <div style={{ fontSize: 8, color: '#6b7280', letterSpacing: '0.15em' }}>IMPRESA EDILE</div>
              </div>
            </div>
            <QRCodeSVG value="https://colabella.net" size={200} level="H" includeMargin={false} bgColor="#ffffff" fgColor="#1a365d"
              imageSettings={{ src: LOGO, height: 36, width: 36, excavate: true }}
            />
            <div style={{ marginTop: 12, fontSize: 11, color: '#1a365d', fontWeight: 600, letterSpacing: '0.05em' }}>www.colabella.net</div>
            <div style={{ fontSize: 9, color: '#9ca3af', marginTop: 2 }}>Scansiona per visitare il sito</div>
          </div>
          <button onClick={() => downloadEl('qr-sito', 'QR_Colabella_SitoWeb')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica QR Sito Web
          </button>
        </div>

        {/* QR 2 - App Gestionale */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-app" style={{ background: '#fff', borderRadius: 16, padding: 24, textAlign: 'center', width: 280 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 14 }}>
              <img src={LOGO} alt="" style={{ width: 32, height: 32 }} crossOrigin="anonymous" />
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: '#1a365d', letterSpacing: '0.08em' }}>COLABELLA GROUP</div>
                <div style={{ fontSize: 8, color: '#6b7280', letterSpacing: '0.15em' }}>GESTIONE CANTIERI</div>
              </div>
            </div>
            <QRCodeSVG value="https://colabella.net/app" size={200} level="H" includeMargin={false} bgColor="#ffffff" fgColor="#2f4858"
              imageSettings={{ src: LOGO, height: 36, width: 36, excavate: true }}
            />
            <div style={{ marginTop: 12, fontSize: 11, color: '#2f4858', fontWeight: 600, letterSpacing: '0.05em' }}>colabella.net/app</div>
            <div style={{ fontSize: 9, color: '#9ca3af', marginTop: 2 }}>Accedi alla gestione cantieri</div>
          </div>
          <button onClick={() => downloadEl('qr-app', 'QR_Colabella_App')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#2f4858', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica QR App
          </button>
        </div>

        {/* QR 3 - Mini per adesivo */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-mini" style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center', width: 280 }}>
            <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
              <QRCodeSVG value="https://colabella.net" size={100} level="H" bgColor="#ffffff" fgColor="#1a365d" />
              <div style={{ textAlign: 'left' }}>
                <img src={LOGO} alt="" style={{ width: 28, height: 28, marginBottom: 6 }} crossOrigin="anonymous" />
                <div style={{ fontSize: 12, fontWeight: 800, color: '#1a365d', letterSpacing: '0.06em' }}>COLABELLA</div>
                <div style={{ fontSize: 12, fontWeight: 300, color: '#1a365d', letterSpacing: '0.06em' }}>GROUP</div>
                <div style={{ fontSize: 8, color: '#6b7280', marginTop: 6 }}>+39 320 271 1608</div>
                <div style={{ fontSize: 8, color: '#6b7280' }}>info@colabella.it</div>
                <div style={{ fontSize: 8, color: '#6b7280' }}>www.colabella.net</div>
              </div>
            </div>
          </div>
          <button onClick={() => downloadEl('qr-mini', 'QR_Colabella_Adesivo')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#22c55e', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica Adesivo
          </button>
        </div>

        {/* QR 4 - Solo QR pulito sfondo trasparente */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-clean" style={{ background: '#fff', borderRadius: 12, padding: 24, textAlign: 'center', width: 280 }}>
            <QRCodeSVG value="https://colabella.net" size={220} level="H" bgColor="#ffffff" fgColor="#000000"
              imageSettings={{ src: LOGO, height: 40, width: 40, excavate: true }}
            />
          </div>
          <button onClick={() => downloadEl('qr-clean', 'QR_Colabella_Pulito')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#f59e0b', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica QR Pulito
          </button>
        </div>

      </div>

      {/* LEMIR QR CODES */}
      <div style={{ textAlign: 'center', margin: '60px 0 30px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 8px', color: '#1a365d' }}>QR Code — Lemir</h1>
        <p style={{ color: '#9ca3af', fontSize: 14 }}>QR code per il sito Lemir — Società Edile</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, maxWidth: 1000, margin: '0 auto' }}>

        {/* QR Lemir Sito */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-lemir-sito" style={{ background: '#fff', borderRadius: 16, padding: 24, textAlign: 'center', width: 280 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 14 }}>
              <div style={{ width: 32, height: 32, borderRadius: 6, background: '#1a365d', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, letterSpacing: '0.05em' }}>LM</div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: '#1a365d', letterSpacing: '0.08em' }}>LEMIR</div>
                <div style={{ fontSize: 8, color: '#6b7280', letterSpacing: '0.15em' }}>SOCIETÀ EDILE</div>
              </div>
            </div>
            <QRCodeSVG value="https://colabella.net/lemir" size={200} level="H" includeMargin={false} bgColor="#ffffff" fgColor="#1a365d" />
            <div style={{ marginTop: 12, fontSize: 11, color: '#1a365d', fontWeight: 600, letterSpacing: '0.05em' }}>colabella.net/lemir</div>
            <div style={{ fontSize: 9, color: '#9ca3af', marginTop: 2 }}>Scansiona per visitare il sito Lemir</div>
          </div>
          <button onClick={() => downloadEl('qr-lemir-sito', 'QR_Lemir_Sito')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#1a365d', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica QR Lemir Sito
          </button>
        </div>

        {/* QR Lemir Adesivo */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-lemir-adesivo" style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center', width: 280 }}>
            <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
              <QRCodeSVG value="https://colabella.net/lemir" size={100} level="H" bgColor="#ffffff" fgColor="#1a365d" />
              <div style={{ textAlign: 'left' }}>
                <div style={{ width: 28, height: 28, borderRadius: 6, background: '#1a365d', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800, marginBottom: 6 }}>LM</div>
                <div style={{ fontSize: 14, fontWeight: 800, color: '#1a365d', letterSpacing: '0.06em' }}>LEMIR</div>
                <div style={{ fontSize: 9, fontWeight: 400, color: '#6b7280' }}>Società Edile</div>
                <div style={{ fontSize: 8, color: '#6b7280', marginTop: 6 }}>+39 320 271 1608</div>
                <div style={{ fontSize: 8, color: '#6b7280' }}>info@lemircc.com</div>
                <div style={{ fontSize: 8, color: '#6b7280' }}>colabella.net/lemir</div>
              </div>
            </div>
          </div>
          <button onClick={() => downloadEl('qr-lemir-adesivo', 'QR_Lemir_Adesivo')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#f97316', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica Adesivo Lemir
          </button>
        </div>

        {/* QR Lemir Pulito */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div id="qr-lemir-clean" style={{ background: '#fff', borderRadius: 12, padding: 24, textAlign: 'center', width: 280 }}>
            <QRCodeSVG value="https://colabella.net/lemir" size={220} level="H" bgColor="#ffffff" fgColor="#1a365d" />
          </div>
          <button onClick={() => downloadEl('qr-lemir-clean', 'QR_Lemir_Pulito')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: '#64748b', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Download size={14} /> Scarica QR Lemir Pulito
          </button>
        </div>

      </div>
    </div>
  );
};

export default QRPage;
